import {
    DoppeActionTypeContentSpecialSettingsMetadata,
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from "../../client-server-common/doppe-action-types/doppe-action-type";

export const doppeActionTypeDebugApi = doppeActionTypeDefineMetadata({
    id: 'io.bymo.action/debug/api',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({}),
    actionSettingsMetadata: {
        contentSettingsMetadata: DoppeActionTypeContentSpecialSettingsMetadata.Ignored,
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false
})